import React, { useEffect, useState } from "react";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { OpClass } from "../../fxms/datas/OpClass";
import { FxUtil } from "../../fxms/datas/FxUtil";
import Box from "@mui/material/Box";
import { v4 as uuidv4 } from 'uuid';
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxCheckBoxBase } from "../../fxms/inputs/FxCheckBox";
import { FxDataGridBase } from "../../fxms/components/grid/FxDataGrid";
import { FxForm, FxFormButtons } from "../../fxms/inputs/FxForm";
import { FxFooter } from "../../fxms/inputs/FxFooter";
import { getDefaultDate } from "../../fxms/inputs/FxDate";
import { FxCheckBoxWeek } from "../../fxms/inputs/FxCheckBox";
import { FxDateBase } from "../../fxms/inputs/FxDate";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxActionBase } from "../../fxms/actions/FxAction";
import { FxSelectComplex, FxSelectCompany, FxSelectPlant, FxSelectProcTypeCd, FxSelectTimeHourCd, FxSelectEnergy, FxSelectFacility, FxSelectPipe } from "../inputs/VupInputs";

export const UI_4_7_CU = (props) => {
  const { isLoaded } = props;
  const { selectedDataId, attrListClass } = props;
  const [ opId, setOpId ] = React.useState("");
  const [checkedValue, setCheckedValue] = React.useState([{id:0, value:""}]);
  const [startTime, setStartTime] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  const [opClass, setOpClass] = React.useState(null);
  const [listClass, setListClass] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [complexInloNo, setComplexInloNo] = React.useState(0);
  const [companyInloNo, setCompanyInloNo] = React.useState(0);
  const [plantInloNo, setPlantInloNo] = React.useState(0);
  const [inputDatas, setInputDatas] = React.useState({});
  const [selectedData, setSelectedData] = React.useState({});


  useEffect(() => {

    console.log("UI_4_7_CU", props);

    if (props.selectedData) {
      let rowData = {};
      let satValue = "";
      let sunValue = "";
      let weekValue = "";


      rowData = props.selectedData;
      if (props.selectedData.satOper) satValue = (props.selectedData.satOper).replace(/시/g, "");
      if (props.selectedData.weekOper) weekValue = (props.selectedData.weekOper).replace(/시/g, "");
      if (props.selectedData.sunOper) sunValue = (props.selectedData.sunOper).replace(/시/g, "");


      function changeToArray(newValue) {
        const timeArray = newValue.split(",").map((time) => time.trim()).filter(Boolean);
        const newTimeArray = timeArray.map((time) => (time === "00" ? "00" : (time < 10 ? "0" + time.toString() : time.toString())));
        return newTimeArray;
      }

      rowData["saturday"] = changeToArray(satValue);
      rowData["holiday"] = changeToArray(sunValue);
      rowData["weekday"] = changeToArray(weekValue);
      setSelectedData(rowData);

      setInputDatas(rowData);
    }

  }, [props.selectedData]);

  function onChangeValue(id, value, object) {
    let newData = { ...inputDatas };

    if (value) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputDatas(newData);

    if (id == "complexInloNo") {
      setComplexInloNo(value);
    }
    else if (id == "companyInloNo") {
      setCompanyInloNo(value);
    }
    else if (id == "plantInloNo") {
      setPlantInloNo(value);
    }
    console.log("UI_4_7_CU onChangeValue", newData);
  }


  function onClick(name) {
    if (name == 'btnRemove') {
      setRows([]);
    } else if (name == "click") {
      let newDatas = { ...inputDatas };

      if (props.selectedDataId) {
        // 수정
        let caller = new FxActionBase("vupFacOper/facOper/"+ props.selectedDataId, "PUT");
        caller.execute(newDatas, function (bret) {
          console.log("UI_4_7_CU click result ", bret);
        });
      } else {
        // 추가
        let caller = new FxActionBase("vupFacOper/facOper", "POST");
        caller.execute(newDatas, function (bret) {
          console.log("UI_4_7_CU click result ", bret);
        });
      }
    }
  }

  if (isLoaded == false) {
    return <></>
  }

  return (
    <>
      <FxForm style={{ width: '800px', borderColor: 'green' }}
        cols={['100px', '300px', '100px', '300px']}
        rows={[
          {
            inputs: ["산업단지명"
              , <FxSelectComplex onChangeValue={onChangeValue} selectedData={selectedData} optionText={"산업단지선택"} id="complexInloNo" name="complexInloNo" width="200px" />
              , "회사명"
              , <FxSelectCompany onChangeValue={onChangeValue} complexInloNo={complexInloNo} selectedData={selectedData} optionText={"회사선택"} id="companyInloNo" name="companyInloNo" width="200px" />
            ]
            , colspan: [1, 1, 1, 1]
          }
          , {
            inputs: ["공장명"
              , <FxSelectPlant onChangeValue={onChangeValue} companyInloNo={companyInloNo} selectedData={selectedData} optionText={"공장선택"} id="plantInloNo" name="plantInloNo" width="200px" />,
            ]
            , colspan: [1, 1, 1, 1]
          }
          , {
            inputs: ["설비명"
              , <FxSelectFacility onChangeValue={onChangeValue} plantInloNo={plantInloNo} optionText={"설비선택"} name='facNo' selectedData={selectedData} width="200px" />
              , "투입인원"
              , <FxTextFieldBase name="inPeopleNum" onChangeValue={onChangeValue} selectedData={selectedData} width="200px" />
            ]
            , colspan: [1, 1, 1, 1]
          }
          , {
            inputs: ["가동요일"
              , "요일별 가동시간"
            ]
            , colspan: [1, 3]
          }
          , {
            inputs: ["평일"
              , <FxSelectTimeHourCd name="weekday" onChangeValue={onChangeValue} selectedData={selectedData} />
            ]
            , colspan: [1, 3]
          }
          , {
            inputs: ["토요일"
              , <FxSelectTimeHourCd name="saturday" onChangeValue={onChangeValue} selectedData={selectedData} />
            ]
            , colspan: [1, 3]
          }
          , {
            inputs: ["공휴일(일요일포함)"
              , <FxSelectTimeHourCd name="holiday" onChangeValue={onChangeValue} selectedData={selectedData} />
            ]
            , colspan: [1, 3]
          }
        ]
        }
      >
      </FxForm>
      <FxFormButtons
        right={[<FxButtonBase key={uuidv4()} name="click" onClick={onClick} text="등록" />]}
      />
      <FxFooter />
    </>
  )
}
